var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCareersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m346.312 90.375v-60.25h-180.625v60.25h-165.687v391.5h512v-391.5zm-150.625-30.25h120.625v30.25h-120.625zm-165.687 60.25h452v93.811l-180.875 68.84v-42.026h-90.25v42.026l-180.875-68.84zm241.125 150.625v65.806l-15.124 7.028-15.126-7.029v-65.805zm210.875 180.875h-452v-205.59l180.875 68.84v40.82l45.127 20.971 45.123-20.972v-40.819l180.875-68.84z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareersIcon);
export default __webpack_public_path__ + "static/media/careers_icon.c0b11c71a5f06fc07844cc5f484b2d1f.svg";
export { ForwardRef as ReactComponent };